import type {VariantProps} from 'class-variance-authority';
import {Slot} from 'radix-ui';
import * as React from 'react';

import {cn} from '@/utils/ui';

import {typographyVariants} from './typography-variants';

export interface TypographyProps
  extends React.HTMLAttributes<HTMLHeadingElement>,
    VariantProps<typeof typographyVariants> {
  asChild?: boolean;
}

const Typography = React.forwardRef<HTMLHeadingElement, TypographyProps>(
  ({className, variant, asChild = false, ...props}, ref) => {
    const Comp = asChild ? Slot.Slot : 'p';
    return (
      <Comp
        className={cn(typographyVariants({variant, className}))}
        ref={ref}
        {...props}
      />
    );
  }
);
Typography.displayName = 'Typography';

export {Typography};
